// extracted by mini-css-extract-plugin
export default {"select":"DocumentRow_select__x-0wL","statusBox":"DocumentRow_statusBox__hHYqy"};